var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_4359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 9.4999C23.9999 9.34709 23.9648 9.19634 23.8974 9.05922C23.8299 8.9221 23.732 8.80226 23.611 8.7089L12.611 0.208898C12.4358 0.073319 12.2205 -0.000244141 11.999 -0.000244141C11.7775 -0.000244141 11.5622 0.073319 11.387 0.208898L0.387 8.7089C0.266403 8.80246 0.168826 8.9224 0.101745 9.05951C0.0346643 9.19661 -0.000139514 9.34726 4.203e-07 9.4999V22.9999C4.203e-07 23.2651 0.105357 23.5195 0.292894 23.707C0.48043 23.8945 0.734784 23.9999 1 23.9999H9C9.13261 23.9999 9.25979 23.9472 9.35355 23.8535C9.44732 23.7597 9.5 23.6325 9.5 23.4999V18.9999C9.5 18.3369 9.76339 17.701 10.2322 17.2321C10.7011 16.7633 11.337 16.4999 12 16.4999C12.663 16.4999 13.2989 16.7633 13.7678 17.2321C14.2366 17.701 14.5 18.3369 14.5 18.9999V23.4999C14.5 23.6325 14.5527 23.7597 14.6464 23.8535C14.7402 23.9472 14.8674 23.9999 15 23.9999H23C23.2652 23.9999 23.5196 23.8945 23.7071 23.707C23.8946 23.5195 24 23.2651 24 22.9999V9.4999Z",
    stroke: "none",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_4359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBold);
export default __webpack_public_path__ + "static/media/home-bold.9e5716234c440f5affbc43db0a00d43c.svg";
export { ForwardRef as ReactComponent };